import { DISPLAY_TIMEZONE } from './constants/index.js';
const INTL_LOCALE = { it: 'it-IT', tr: 'tr-TR' };
/** Formats an instant in Europe/Rome, in the user's locale. */
export function formatDateTime(value, locale) {
    return new Intl.DateTimeFormat(INTL_LOCALE[locale], {
        timeZone: DISPLAY_TIMEZONE,
        dateStyle: 'short',
        timeStyle: 'short',
    }).format(new Date(value));
}
export function formatDate(value, locale) {
    return new Intl.DateTimeFormat(INTL_LOCALE[locale], {
        timeZone: DISPLAY_TIMEZONE,
        dateStyle: 'short',
    }).format(new Date(value));
}
export function formatNumber(value, locale, maximumFractionDigits = 2) {
    return new Intl.NumberFormat(INTL_LOCALE[locale], { maximumFractionDigits }).format(value);
}
/** `YYYY-MM-DD` for the given instant as seen in Europe/Rome — the business day. */
export function businessDay(value = new Date()) {
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: DISPLAY_TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(new Date(value));
    return parts;
}
export function secondsBetween(from, to) {
    return Math.round((new Date(to).getTime() - new Date(from).getTime()) / 1000);
}
//# sourceMappingURL=datetime.js.map